<template>
  <div class="flex items-center flex-start">
    <div class="db-ns dn">
      <font-awesome-icon class="iconColor pa2" icon="bars"/>
    </div>
    <div class="image-container">
      <img v-show="user.picture" class="mw-100 h-100" :src="picture">
    </div>
  </div>
</template>

<script>
  import consts from '@/consts'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import {mapGetters} from 'vuex'

  export default {
    name: 'user-info',
    components: {
      FontAwesomeIcon
    },
    computed: {
      ...mapGetters('user', [
        'isLoggedIn',
        'isSubscribed',
        'isProducer',
        'user'
      ]),
      picture () {
        if (this.user.picture) {
          return consts.MEDIA_BASE_URL + this.user.picture
        } else {
          return '/static/assets/Img_Avatar_generico_Beathey.jpg'
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  .user-name {
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .image-container {
    height: $navigation-height;
    width: $navigation-height;
    min-width: $navigation-height;
  }

  @media (max-width: 780px) {
    .user-name {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/UserInfo.vue